import type { KaminoVaultPosition, PsyFiVault, TulipStrategyVaultPosition, TulipVault } from "@stepfinance/vaults";
import { createContext, useContext, useState } from "react";

import { useTulipVaults } from "../hooks";
import { useKaminoVaults } from "../hooks/vaults/useKaminoVaults";
import type { KatanaOptionVaultPosition } from "../hooks/vaults/useKatanaOptionVaults";
import { useKatanaOptionVaults } from "../hooks/vaults/useKatanaOptionVaults";
import { usePsyFiVaults } from "../hooks/vaults/usePsyFiVaults";
import { useTulipStrategyVaults } from "../hooks/vaults/useTulipStrategyVaults";

type VaultContextState = {
  kaminoVaults: KaminoVaultPosition[];
  katanaOptionVaults: KatanaOptionVaultPosition[];
  psyFiVaults: PsyFiVault[];
  tulipVaults: TulipVault[];
  tulipStrategyVaults: TulipStrategyVaultPosition[];

  vaultsBalance: number;
  setVaultsBalance: (balance: number) => void;
};

const initialState: VaultContextState = {
  kaminoVaults: [],
  katanaOptionVaults: [],
  psyFiVaults: [],
  tulipVaults: [],
  tulipStrategyVaults: [],

  setVaultsBalance: () => {},
  vaultsBalance: 0,
};

const VaultsContext = createContext<VaultContextState>(initialState);

export const VaultsContextProvider = ({ children }) => {
  const tulipVaults = useTulipVaults();
  const tulipStrategyVaults = useTulipStrategyVaults();
  const katanaOptionVaults = useKatanaOptionVaults();
  const psyFiVaults = usePsyFiVaults();
  const kaminoVaults = useKaminoVaults();

  const [vaultsBalance, setVaultsBalance] = useState(0);

  return (
    <VaultsContext.Provider
      value={{
        kaminoVaults,
        katanaOptionVaults,
        psyFiVaults,
        tulipVaults,
        tulipStrategyVaults,
        vaultsBalance,
        setVaultsBalance,
      }}
    >
      {children}
    </VaultsContext.Provider>
  );
};

export const useVaults = () => useContext(VaultsContext);
